'use client'

import { useEffect } from 'react'
import { useSearchParams } from 'next/navigation'

interface EmailConfirmationHandlerProps {
  onConfirmed: () => void
}

/**
 * Handler component that checks URL parameters for email confirmation
 * Separated from main page to handle Suspense boundary for useSearchParams
 */
export function EmailConfirmationHandler({ onConfirmed }: EmailConfirmationHandlerProps) {
  const searchParams = useSearchParams()

  useEffect(() => {
    // Check for Supabase confirmation parameters
    const confirmed = searchParams.get('confirmed')
    
    // Show confirmation popover if user is coming from email confirmation
    if (confirmed === 'true') {
      onConfirmed()
      
      // Clean up URL parameters
      if (typeof window !== 'undefined') {
        const url = new URL(window.location.href)
        url.searchParams.delete('confirmed')
        url.searchParams.delete('token_hash')
        url.searchParams.delete('type')
        // Also clean up hash parameters that Supabase adds
        url.hash = ''
        window.history.replaceState({}, '', url.toString())
      }
    }
  }, [searchParams, onConfirmed])

  return null
}

